import { render } from "./BannerItem.vue?vue&type=template&id=3f81644e&scoped=true"
import script from "./BannerItem.vue?vue&type=script&lang=js"
export * from "./BannerItem.vue?vue&type=script&lang=js"

import "./BannerItem.vue?vue&type=style&index=0&id=3f81644e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f81644e"]])

export default __exports__